import type * as Types from '@shared/types/graphqlGenerated';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
export type SignInPathLoginQueryVariables = Types.Exact<{
  email: Types.Scalars['String']['input'];
}>;


export type SignInPathLoginQuery = { signInPath: string };


export const SignInPathLoginQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SignInPath_Login_Query"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signInPath"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}]}}]} as unknown as DocumentNode;
export type SignInPathLoginQueryQueryResult = Apollo.QueryResult<SignInPathLoginQuery, SignInPathLoginQueryVariables>;

export function useSignInPathLoginQuery(
  baseOptions: Apollo.QueryHookOptions<SignInPathLoginQuery, SignInPathLoginQueryVariables> & ({ variables: SignInPathLoginQueryVariables; skip?: boolean; } | { skip: boolean; })
) {
  return Apollo.useQuery<SignInPathLoginQuery, SignInPathLoginQueryVariables>(
    SignInPathLoginQueryDocument,
    baseOptions
  );
}

export function useSignInPathLoginLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignInPathLoginQuery, SignInPathLoginQueryVariables>) {
  return Apollo.useLazyQuery<SignInPathLoginQuery, SignInPathLoginQueryVariables>(
    SignInPathLoginQueryDocument,
    baseOptions
  );
}

export function useSignInPathLoginSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SignInPathLoginQuery, SignInPathLoginQueryVariables>) {
  return Apollo.useSuspenseQuery<SignInPathLoginQuery, SignInPathLoginQueryVariables>(
    SignInPathLoginQueryDocument,
    baseOptions
  );
}
